<template>
  <property-list :value="propertyList" />
</template>
``
<script>
import { getFullName } from '@/app/library/getFullName';
import { getCountry } from '@/app/library/country-state-picker';
import { convertAddressToString } from '@/app/library/convertAddressToString';
import PropertyList from '@/app/components/PropertyList';

export default {
  name: 'ConsumerProfilePropertyList',
  components: {
    PropertyList
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    propertyList() {
      return [
        {
          name: this.$t('consumer-profile.name'),
          value: getFullName(this.value.firstName, this.value.lastName)
        },
        {
          name: this.$t('consumer-profile.login'),
          value: this.value.login
        },
        {
          name: this.$t('consumer-profile.email'),
          value: this.value.email
        },
        {
          name: this.$t('consumer-profile.password'),
          value: '**************'
        },
        {
          name: this.$t('consumer-profile.phone'),
          value: this.value.phone
        },
        {
          name: this.$t('consumer-profile.address'),
          value: convertAddressToString({
            address: this.value.address,
            city: this.value.city,
            zipCode: this.value.zipCode,
            state: this.value.state,
            country: getCountry(this.value.country)?.name
          })
        }
      ];
    }
  }
};
</script>
